import { IPersona } from './../interfaces/IPersona';
import { IEsecutore } from './../interfaces/IEsecutore';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';
import { ITipoRichiesta } from '../interfaces/ITipoRichiesta';
import { ICommessa } from '../interfaces/ICommessa';
import { IRichiesta } from '../interfaces/IRichiesta';
import { ITipoContratto } from '../interfaces/ITipoContratto';
import { ICantiere } from '../interfaces/ICantiere';
import * as Enum from '../utils/enums'
import * as Constants from '../utils/constants'
import { Loading } from '../utils/loading';
import * as Moment from 'moment'
import { IStatoRichiesta } from '../interfaces/IStatoRichiesta';
import { RequestBuilder } from '../classes/request-builder';
import { RichiestaService } from '../services/richiesta.service';
import { finalize } from 'rxjs/operators';
import { AlertUtil } from '../utils/alert-util';
import { MezziService } from '../services/mezzi.service';
import { PersoneService } from '../services/persone.service';
import { IMezzo } from '../interfaces/IMezzo';
import { EsecutoreService } from '../services/esecutore.service';
import { Util } from '../utils/util';

@Component({
  selector: 'app-richiesta-modal',
  templateUrl: './richiesta-modal.component.html',
  styleUrls: ['./richiesta-modal.component.css']
})
export class RichiestaModalComponent implements OnInit {

  commessa: ICommessa
  tipiRichiesta: ITipoRichiesta[]
  currentTipiRichiesta: ITipoRichiesta[]  // tipiRichiesta for select based on radio button value
  currentTipiContratto: ITipoContratto[]  // tipoContratto for select based on tipiRichiesta select value
  cantieri: ICantiere[]                   // cantieri of this commessa
  currentEsecutori: IEsecutore[]          // array esecutori legati alla commessa

  richiestaForm: FormGroup

  isRichiestaForCantiere: boolean         // determines whether this richiesta is for commessa or for cantiere
  isRichiestaForContratto: boolean         // determines whether this richiesta is for contratto

  isRichiestaMezzi: boolean
  isRichiestaPersone: boolean

  RTF = Enum.REQUEST_TYPE_FOR_ENUM  //export enum for html

  isEsecutore: boolean

  mezzi: IMezzo[]  // for dropdown
  persone: IPersona[]  // for dropdown

  constructor(private formBuilder: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private richiestaService: RichiestaService,
    private alertUtil: AlertUtil,
    private mezziService: MezziService,
    private esecutoreService: EsecutoreService,
    private personaService: PersoneService) {
    this.commessa = this.config.data.commessa
    this.currentEsecutori = this.config.data.currentEsecutori

    this.cantieri = this.commessa.Cantieri

    this.isRichiestaForCantiere = false
    this.isRichiestaForContratto = false

    this.isEsecutore = false
    //check user role
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    if (userRole == Enum.USER_TYPE_ENUM.ESECUTORE) {
      this.isEsecutore = true
      this.isRichiestaForCantiere = true
    }

    // set tipi richiesta by commessa and role
    this.getTipiRichiestaByCommessa(this.config.data.tipiRichiesta)

    //build form group
    this.buildForm()

    //force tipiRichiesta select creation
    this.requestForChange()
  }

  buildForm() {
    this.richiestaForm = this.formBuilder.group({
      'richiestaPer': [this.isEsecutore || this.isRichiestaForCantiere ? Enum.REQUEST_TYPE_FOR_ENUM.CANTIERE : Enum.REQUEST_TYPE_FOR_ENUM.COMMESSA],
      'cantiere': ['', this.isRichiestaForCantiere ? Validators.required : ''],
      'tipoRichiesta': ['', Validators.required],
      'tipoContratto': ['', Validators.required],
      'esecutore': [''], //default not required
      'mezzi': [''], //default not required
      'persone': [''], //default not required
      'riferimento': ['', Validators.required],
      'numeroRiferimento': [''],
      'emailRiferimento': ['', Validators.email]
    })
  }

  ngOnInit() {
  }

  /**
   * callback fired when commessa form is submitted
   */
  onSubmit() {
    //retrieve values from form
    let cantiere = this.richiestaForm.controls['cantiere'].value
    let tipoContratto = this.richiestaForm.controls['tipoContratto'].value
    let riferimento = this.richiestaForm.controls['riferimento'].value
    let numeroRiferimento = this.richiestaForm.controls['numeroRiferimento'].value
    let emailRiferimento = this.richiestaForm.controls['emailRiferimento'].value

    let esecutore: IEsecutore = null // check tipo contratto is esecutore
    if (this.isRichiestaForContratto) {
      esecutore = this.richiestaForm.controls['esecutore'].value
    }

    let listMezzi = this.richiestaForm.controls['mezzi'].value
    let listPersone = this.richiestaForm.controls['persone'].value

    let listId = this.getListaId(listMezzi ? listMezzi : (listPersone ? listPersone : null))

    let dataCreazioneRichiesta = Moment().format("YYYY-MM-DDTHH:mm:ss")

    let statoRichiesta: IStatoRichiesta = {
      Id: Enum.REQUEST_STATE_ENUM.BOZZA,
      Nome: Enum.REQUEST_STATE_NAME_ENUM.BOZZA
    }

    //delete objects references
    if (this.isRichiestaForCantiere) {
      cantiere.Richieste = null
    }
    else {
      // request for commessa
      this.commessa.Richieste = null
      this.commessa.Cantieri = null
    }

    // set mezzi and persone as null from esecutore if tipo richiesta is contratto
    if (esecutore) {
      esecutore.Mezzi = null
      esecutore.Persone = null
    }


    //build richiesta
    let newRichiesta: IRichiesta = {
      Data_creazione: dataCreazioneRichiesta,
      Riferimento: riferimento,
      Numero_riferimento: numeroRiferimento,
      Email_riferimento: emailRiferimento,
      GUID_utente: localStorage.getItem(Constants.LS_USER_GUID),
      Cantiere: this.isRichiestaForCantiere ? cantiere : null,
      TipoContratto: tipoContratto,
      StatoRichiesta: statoRichiesta,
      Commessa: this.isRichiestaForCantiere ? null : this.commessa,
      Esecutore: esecutore, //default null,
      ItemsSelezionati: listId
    }

    // confirm save
    this.alertUtil.showConfirmationAlert("LBL_CONFIRM_SAVE_RICHIESTA", null, null, null, null, () => {
      //save richiesta if user confirm
      Loading.isLoading = true
      let reqBuilderPath = this.isRichiestaForCantiere ? ['Cantiere', 'TipoContratto', 'StatoRichiesta'] : ['TipoContratto', 'StatoRichiesta', 'Commessa']
      let reqBuilder = new RequestBuilder(newRichiesta, reqBuilderPath)
      this.richiestaService.save(reqBuilder).pipe(finalize(() => {
        Loading.isLoading = false
      })).subscribe(
        response => {
          if (response.data) {
            //set Censita TRUE if new richiesta is for censimento
            let tipoRichiesta = this.richiestaForm.controls['tipoRichiesta'].value
            if (tipoRichiesta.Id == Enum.REQUEST_TYPE_ENUM.CENSIMENTO) {
              this.commessa.Censita = true
            }

            this.alertUtil.showAlert("LBL_NEW_RICHIESTA_SUCCESS", null, null, null, () => {
              this.ref.close(newRichiesta)
            })
          }
          else if (response.error) {
            let errorKey = "LBL_ERROR_" + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            console.log("ERROR: " + response.error.Stack)
          }
          else {
            this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
          }
        },
        error => {
          let errorKey = "LBL_HTTP_ERROR_0"
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
    })
  }

  /**
   * callback fired when richiestaPer radio button changes
   */
  requestForChange() {
    let richiestaPer = this.richiestaForm.controls['richiestaPer'].value
    this.isRichiestaForContratto = false
    this.richiestaForm.controls['esecutore'].setValue(null)
    this.richiestaForm.controls['tipoContratto'].setValue(null)
    this.richiestaForm.controls['tipoRichiesta'].setValue(null)
    this.isRichiestaForCantiere = richiestaPer == Enum.REQUEST_TYPE_FOR_ENUM.CANTIERE

    //rebuild form each time you choose CA or CO by radiobutton 
    this.buildForm()

    this.currentTipiRichiesta = []
    this.tipiRichiesta.forEach(tipoRichiesta => {
      if (tipoRichiesta.Tipo == richiestaPer) {
        this.currentTipiRichiesta.push(tipoRichiesta)
      }
    })
  }

  /**
   * callback fired when tipoRichiesta dropdown changes
   * @param event 
   */
  onTipoRichiestaChange(event: any) {
    let tipoRichiestaChoosen = event.value
    this.isRichiestaMezzi = tipoRichiestaChoosen.Nome == Constants.TIPO_INTEGRAZIONE_MEZZI
    this.isRichiestaPersone = tipoRichiestaChoosen.Nome == Constants.TIPO_INTEGRAZIONE_PERSONE

    this.isRichiestaForContratto =
      tipoRichiestaChoosen.Nome == Constants.TIPO_RICHIESTA_CONTRATTO_COMMESSA
      || tipoRichiestaChoosen.Nome == Constants.TIPO_RICHIESTA_CONTRATTO_CANTIERE
      || tipoRichiestaChoosen.Nome == Constants.TIPO_RICHIESTA_CONTRATTO_ESECUTORE
    this.currentTipiRichiesta.forEach(tipoRichiesta => {
      if (tipoRichiesta.Nome == tipoRichiestaChoosen.Nome) {
        this.currentTipiContratto = tipoRichiesta.TipiContratto
      }
    })
    if (this.isRichiestaPersone) {
      this.mezzi = []
      this.getAllPersone()
    }
    if (this.isRichiestaMezzi) {
      this.persone = []
      this.getAllMezzi()
    }
    //SE LA RICHIESTA == CONTRATTO COMMESSA VALORIZZO DI NUOVO LA LISTA DEGLI ESECUTORI
    if (tipoRichiestaChoosen.Nome == Constants.TIPO_RICHIESTA_CONTRATTO_COMMESSA) {
      this.currentEsecutori = []
      this.getAllEsecutoriConStatoAntimafia()
    } else {
      this.getAllEsecutori()
    }
    this.handleTipoRichiesta();
  }

  /**
   * 
   */
  private handleTipoRichiesta() {
    if (!this.isRichiestaForContratto) {
      this.richiestaForm.controls['esecutore'].setValue(null);
      this.richiestaForm.controls['esecutore'].setValidators(null);
      this.richiestaForm.controls['esecutore'].updateValueAndValidity();
    }
    else {
      //if richiesta is contratto esecutore required
      this.richiestaForm.controls['esecutore'].setValidators(Validators.required);
    }

    if (this.isRichiestaMezzi) {
      this.richiestaForm.controls['mezzi'].setValidators(Validators.required);
      this.richiestaForm.controls['persone'].setValue(null);
      this.richiestaForm.controls['persone'].setValidators(null);
      this.richiestaForm.controls['persone'].updateValueAndValidity();
    }
    if (this.isRichiestaPersone) {
      this.richiestaForm.controls['persone'].setValidators(Validators.required);
      this.richiestaForm.controls['mezzi'].setValue(null);
      this.richiestaForm.controls['mezzi'].setValidators(null);
      this.richiestaForm.controls['mezzi'].updateValueAndValidity();
    }
    //aggiunto controllo in modo da resettare i validators a mezzi e persone quando il tipo di richiesta selezionata è ITP
    if (!this.isRichiestaPersone && !this.isRichiestaMezzi) {
      this.richiestaForm.controls['persone'].setValue(null);
      this.richiestaForm.controls['persone'].setValidators(null);
      this.richiestaForm.controls['mezzi'].setValue(null);
      this.richiestaForm.controls['mezzi'].setValidators(null);
      this.richiestaForm.controls['persone'].updateValueAndValidity();
      this.richiestaForm.controls['mezzi'].updateValueAndValidity();
    } 
  }

  /**
   * callback fired when tipoContratto dropdown changes
   * @param event 
   */
  onTipoContrattoChange(event: any) {
    let tipoContrattoChoosen = event.value
    this.isRichiestaForContratto = tipoContrattoChoosen.Nome == Constants.TIPO_CONTRATTO
      || tipoContrattoChoosen.Nome == Constants.TIPO_RICHIESTA_SUBAFFIDAMENTO
      || tipoContrattoChoosen.Nome == Constants.TIPO_RICHIESTA_SUBAPPALTO
      || tipoContrattoChoosen.Nome == Constants.TIPO_RICHIESTA_SUBAPPALTO_SERVIZI
      || tipoContrattoChoosen.Nome == Constants.TIPO_RICHIESTA_VERIFICA_ANTIMAFIA
    this.handleTipoRichiesta();

  }

  /**
   * get correct tipiRichiesta based on current commessa
   * @param tipiRichiestaArray 
   */
  private getTipiRichiestaByCommessa(tipiRichiestaArray: ITipoRichiesta[]) {
    this.tipiRichiesta = []

    // if commessa is censita push into tipiRichista all tipiRichiestaArray but censimento
    if (this.commessa.Censita) {
      tipiRichiestaArray.forEach(tipoRichiesta => {
        if (tipoRichiesta.Id != Enum.REQUEST_TYPE_ENUM.CENSIMENTO) {
          // not insert contratto for esecutore
          if (!((tipoRichiesta.Id == Enum.REQUEST_TYPE_ENUM.CONTRATTO_CANTIERE || tipoRichiesta.Id == Enum.REQUEST_TYPE_ENUM.CONTRATTO_COMMESSA) && this.isEsecutore)) {
            this.tipiRichiesta.push(tipoRichiesta)
          } else if (tipoRichiesta.Id != Enum.REQUEST_TYPE_ENUM.CONTRATTO_CANTIERE) {
            this.tipiRichiesta.push(tipoRichiesta)
          }
        }
      })
    }
    else {
      // if commessa is not censita push into tipiRichista only censimento
      tipiRichiestaArray.forEach(tipoRichiesta => {
        if (tipoRichiesta.Id == Enum.REQUEST_TYPE_ENUM.CENSIMENTO) {
          this.tipiRichiesta.push(tipoRichiesta)
        }
      })
    }
  }

  /**
   * get all persone
   */
  getAllPersone(payload?: any) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(payload != null ? payload : {})
    this.personaService.getAllPersone(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.persone = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
  * get all mezzi
  */
  getAllMezzi(payload?: any) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(payload != null ? payload : {})
    this.mezziService.getAllMezzi(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.mezzi = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * return lista id of multiselect
   * @param list 
   */
  getListaId(list: any[]): number[] {
    let listId: number[] = []
    if (list && list.length > 0) {
      list.forEach(item => {
        listId.push(item.Id)
      });
    }
    return listId
  }

  /**
   * recupero la lista degli esecutori con lo stato antimafia 
   */
  getAllEsecutoriConStatoAntimafia() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.esecutoreService.fetchEsecutoriStatoAntimafia(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.currentEsecutori = response.data
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
    * get all esecutori
    */
  getAllEsecutori() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.esecutoreService.fetchEsecutori(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.currentEsecutori = response.data
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * check form for disabled btn
   * @returns 
   */
  richiestaBtnDisabled() {
    return !this.richiestaForm.valid
      || this.richiestaForm.controls['riferimento'].value === ""
      || Util.isBlank(this.richiestaForm.controls['riferimento'].value)
  }

}
